export const accessToken = MAPBOX_ACESS_TOKEN || "";

export const apiUrl = "https://reindeer-locations-tracker.azurewebsites.net/api/getReindeerLocations";
export const apiKey = REINDEER_API_KEY || "";